/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：77
 */

"use strict"

var r
var o
var i
var a
export { r as c }
export { o as b }
export { i as d }
export { a };
(function (e) {
  e.DEFAULT = "DEFAULT"
  e.PRIMARY = "PRIMARY"
})(r || (r = {}));
(function (e) {
  e.HORIZONTAL = "HORIZONTAL"
  e.VERTICAL = "VERTICAL"
})(o || (o = {}));
(function (e) {
  e.TEMPLATE = "TEMPLATE"
  e.IMAGE = "IMAGE"
})(i || (i = {}));
(function (e) {
  e.BACKGROUND = "BACKGROUND"
  e.TRACK = "TRACK"
  e.HANDLE = "HANDLE"
})(a || (a = {}))
export default a
